import type { EmojiItem } from "../model";
import emojiData from "./emojiItems.json";

export const EMOJI_ITEMS = emojiData as Record<string, EmojiItem>;
